import * as React from "react";
import { connect } from "react-redux";
import configureStore from "../store/configureStore";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import rootReducer from "../reducers";
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import * as Tools from "../helpers/Tools";
import * as types from "../constants/actionTypes";
import configureFetch from "../helpers/configureFetch";

//import 'bootstrap/dist/css/bootstrap.min.css';
// import scss to cause webpack to see it as a dependency...
import "../scss/include/index.scss";
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { logReactError } from "../api/loggingApi";

import Cookies from "cookies-js";

import RefreshOnNav from "./common/RefreshOnNav";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";


import AppRoutes from "./AppRoutes";
import HistoryBinder from "./common/HistoryBinder";
import MessageSpinner from "./common/MessageSpinner"

import MainErrorBoundary from "./common/MainErrorBoundary";
import { logUI } from "../api/andyliticsApi";
/* Planning for removing firebase/GA4 I think the only info we have been capturing was via GA3 aka UA (Univeral Analytics) 
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
var firebaseConfig = {
    apiKey: window.serverData.data.bswFirebaseapiKey,
    authDomain: window.serverData.data.bswFirebaseauthDomain,
    databaseURL: window.serverData.data.bswFirebasedatabaseURL,
    projectId: window.serverData.data.bswFirebaseprojectId,
    storageBucket: window.serverData.data.bswFirebasestorageBucket,
    messagingSenderId: window.serverData.data.bswFirebasemessagingSenderId,
    appId: window.serverData.data.bswFirebaseappId,
    measurementId: window.serverData.data.bswFirebasemeasurementId
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);//
*/
window.store = null;

// Scrub logout message when leaving the page (for any reason, including page refresh)
try {
    window.document.body.onbeforeunload = function (e) {
        try {
            let sCookie = Cookies.get(window.serverData.data.environment + "-root-Domain");
            if (sCookie) {
                let oCookie = JSON.parse(sCookie);
                oCookie.domain.lom = null;
                let sDomain = Tools.getDomain();

                Cookies.set(window.serverData.data.environment + "-root-Domain", JSON.stringify(oCookie), { domain: sDomain, path: "/" });
            }
        }
        catch (E2) {

        }
    };
}
catch (E) {

}

window.persistor = null;
configureFetch();


/**
 * Main app component.
 */
export class App extends React.Component {

    constructor(params) {
        super(params);
        this.serverData = window.serverData.data;
        this.menuItems = this.serverData.activeMenuItems;
        this.loginCompleted = this.loginCompleted.bind(this);
        this.handleAppRefresh = this.handleAppRefresh.bind(this);

        window.appInstanceID = window.serverData.data.appInstanceID;

        window.store = configureStore(this.serverData);
        window.persistor = persistStore(store);
        //debugger;
        window.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: window.serverData.data.instrumentationKey,
                enableDebug: false,
                disableFetchTracking: false,
                disableAjaxTracking: false,
                cookieDomain: Tools.getDomain(),
                enableCorsCorrelation: window.serverData.data.enableCorsCorrelation,
                correlationHeaderExcludedDomains: [
                    'rxapi-tst.bswhive.com',
                    'rx.bswapi.com'
                ],
                autoTrackPageVisitTime: true
            }
        });
        window.ai = appInsights.loadAppInsights();

        let telemetryInitializer = function () {
            appInsights.addTelemetryInitializer(function (envelope) {
                var telemetryItem = envelope.baseData;
                let oState = window.store.getState();
                let oDomain = oState ? oState.domain : null;
                if (oDomain) {
                    let sCorrelationID = oDomain.c || Cookies.get("bsw-CorrelationId");
                    let sSessionID = oDomain.s || Cookies.get("bsw-SessionId");
                    let sUserName = oDomain.un || window.currentUserName;

                    telemetryItem.properties = telemetryItem.properties || {};
                    if (sCorrelationID) {
                        telemetryItem.properties["AL_CorrelationID"] = sCorrelationID;
                    }
                    if (sSessionID) {
                        telemetryItem.properties["AL_SessionID"] = sSessionID;
                    }
                    if (sUserName && sUserName !== "") {
                        appInsights.setAuthenticatedUserContext(sUserName);
                    }
                }
            });
        };

        if (appInsights.queue !== undefined) {
            appInsights.queue.push(telemetryInitializer);
        } else {
            telemetryInitializer();
        }

        if (window.serverData.data.startupDebug) {
            debugger; // <- do NOT comment out, read the code please
        }

        this.appUpdate = null;

        var thisDate = new Date();
        var bNeedsAuthenticate = false;
        if (typeof window !== 'undefined') {
            store.dispatch({ type: types.SET_SERVER_DATA, serverData: window.serverData.data });
            store.dispatch({ type: types.LOAD_TERMS_AND_CONDITIONS });
            let authToken = Cookies("AuthToken" + this.serverData.environment);
            let oState = window.store.getState();
            if (oState && oState.localStorage && oState.localStorage.isLoggedIn) {
                //debugger;
                if (oState.localStorage.lastLoaded) {
                    var iDiff = thisDate - Date.parse(oState.localStorage.lastLoaded);
                    if ((iDiff / 1000) < 30) {
                        //                        authToken = oState.localStorage.token;
                        //                        store.dispatch({
                        //                            type: types.ON_USER_AUTHENTICATE_SUCCESS,
                        //                            access_token: oState.localStorage.token,
                        //                            refresh_token: oState.localStorage.refreshToken,
                        //                            Logins: "",
                        //                            callback: this.loginCompleted
                        //                        });
                        //                        bNeedsAuthenticate = true;
                    }
                }
            }
            if (!authToken && oState && oState.domain && oState.domain.t) {
                authToken = oState.domain.t;
            }
            // setup server data first

            if (authToken) {
                bNeedsAuthenticate = true;
                //debugger;
                store.dispatch({ type: types.VERIFY_LOGIN, token: authToken, DontClearRedirectURL: true, forceRefresh: true, callback: this.loginCompleted });
            }
            store.dispatch({ type: types.GET_APP_UPDATE });
            if (oState.domain && oState.domain.t) {
                store.dispatch({ type: types.MEMBERSHIP_GET_START });
            }
        }
        //debugger;
        this.state = { NeedsAuthenticate: bNeedsAuthenticate, Authenticated: false };

        try {
            window.addEventListener("storage", (event) => {
                if (event && event.key && event.key == "logoutFrom" && event.newValue !== event.oldValue && event.newValue !== window.serverData.data.appInstanceID) {
                    //debugger;
                    window.store.dispatch({ type: types.LOGOUT, fromWindowListener: true });
                }
                if (event && event.key && event.key == "root" && event.newValue !== event.oldValue) {
                    var oRoot = JSON.parse(event.newValue);
                    var oLocalStorage = JSON.parse(oRoot.localStorage);
                    if (oLocalStorage) {
                        //debugger;
                        if (oLocalStorage.appInstanceID != window.serverData.data.appInstanceID) {
                            let oState = window.store.getState();
                            var sCurrToken;
                            var sCurrRefresh;
                            if (oState && oState.domain && oState.domain.t) {
                                sCurrToken = oState.domain.t;
                                sCurrRefresh = oState.domain.rt;
                            }
                            if (oLocalStorage.token != sCurrToken || oLocalStorage.refreshToken != sCurrRefresh) {
                                //debugger;
                                window.store.dispatch({ ...oLocalStorage, type: types.UPDATE_TOKEN_AND_REFRESH_TOKEN });
                                if (oLocalStorage.token) {
                                    window.store.dispatch({ type: types.VERIFY_LOGIN, token: oLocalStorage.token, DontClearRedirectURL: true, forceRefresh: false, callback: this.loginCompleted });
                                }
                            }
                        }
                    }
                }

            });
        }
        catch (e) {

        }

        //debugger;
    }

    //Handle Refresh Scenarios
    componentDidMount() {
        if (typeof window !== 'undefined' && !this.appUpdate) {
            //debugger;
            this.appUpdate = window.setInterval(
                this.handleAppRefresh,
                window.serverData.data.appRefreshTimer ? window.serverData.data.appRefreshTimer * 60 * 1000 : 60 * 1000);
        }


    }

    componentWillUnmount() {
        if (typeof window !== 'undefined' && this.appUpdate) window.clearInterval(this.appUpdate);
    }

    /**
     * Global error trap; logs error info to the api.
     * 
     * @param {any} errorMsg react error
     * @param {any} errorInfo react error info
     */
    componentDidCatch(errorMsg, errorInfo) {
        console.error(errorMsg, errorInfo);
        let json = { error: errorMsg, componentStack: errorInfo };
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(errorMsg), JSON.stringify(errorInfo));
    }

    loginCompleted() {
        //debugger;
        this.setState({ Authenticated: true });
    }

    //Hard Refresh with kill switch, Soft Refresh based on version number
    handleAppRefresh() {
       
        //debugger;
        if ((typeof window !== 'undefined')) { // && (window.location.href.toLowerCase().indexOf("/login") < 0)) {
            //debugger;
            window.store.dispatch({ type: types.GET_APP_UPDATE });
        }
        else {
            //debugger;
        }

    }

    render() {
        const {
            isLoggedIn,
            hasMyChart,
            hasHealthPlan,
            hasPharmacy,
            isHome,
            isPharmacy
        } = this.props;
        var bIncludeLoginShim = isHome;
        const {
            NeedsAuthenticate, Authenticated
        } = this.state;
        var oBody;
        if (NeedsAuthenticate && !Authenticated) {
            //debugger;
            bIncludeLoginShim = false;
            oBody = (<div><HistoryBinder /><MessageSpinner message=""></MessageSpinner></div>); // we need to do this for auto-login scenarios to quickly bind the history object before the app is triggered
        } else {
            oBody = <AppRoutes isHome={isHome} isPharmacy={isPharmacy} isServerSide={false} />;
        }

        //debugger;
        return (
            <MainErrorBoundary>
                {
                    bIncludeLoginShim &&   // LoginShim isn't needed by the pharmacy
                    <iframe src="/home/LoginShim" name="LoginShim" id="LoginShim" title="Login Shim" style={{ position: "absolute", left: -10, top: -10, height: 5, width: 5 }} aria-hidden="true" />
                }
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <BrowserRouter>
                            {oBody}
                        </BrowserRouter>
                    </PersistGate>
                </Provider>
            </MainErrorBoundary>
        );
    }
}


export default App;